var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39435 8.07808C6.95547 9.24678 7.7204 10.3421 8.68913 11.3109C9.65786 12.2796 10.7532 13.0445 11.9219 13.6057C12.0224 13.6539 12.0727 13.6781 12.1363 13.6966C12.3623 13.7625 12.6399 13.7152 12.8313 13.5781C12.8852 13.5395 12.9313 13.4934 13.0234 13.4013C13.3053 13.1194 13.4462 12.9785 13.5879 12.8864C14.1223 12.5389 14.8113 12.5389 15.3458 12.8864C15.4875 12.9785 15.6284 13.1194 15.9103 13.4013L16.0674 13.5584C16.4958 13.9868 16.71 14.2011 16.8264 14.4311C17.0579 14.8887 17.0579 15.4291 16.8264 15.8867C16.71 16.1168 16.4958 16.331 16.0674 16.7594L15.9403 16.8865C15.5133 17.3135 15.2998 17.527 15.0095 17.6901C14.6874 17.871 14.1872 18.0011 13.8178 18C13.4848 17.999 13.2573 17.9344 12.8022 17.8053C10.3567 17.1111 8.04899 15.8015 6.12377 13.8762C4.19854 11.951 2.88887 9.64333 2.19474 7.19776C2.06558 6.74269 2.001 6.51516 2.00001 6.18224C1.99891 5.81281 2.129 5.31256 2.30993 4.99047C2.47299 4.70021 2.68648 4.48672 3.11347 4.05973L3.24056 3.93264C3.66902 3.50418 3.88324 3.28995 4.11332 3.17358C4.5709 2.94214 5.11128 2.94214 5.56885 3.17358C5.79893 3.28995 6.01316 3.50418 6.44162 3.93264L6.59872 4.08974C6.88058 4.3716 7.02151 4.51253 7.11365 4.65425C7.46112 5.18868 7.46112 5.87765 7.11365 6.41209C7.02151 6.5538 6.88058 6.69473 6.59872 6.97659C6.50656 7.06875 6.46048 7.11483 6.42191 7.16869C6.28485 7.36011 6.23752 7.63766 6.30341 7.86368C6.32195 7.92729 6.34608 7.97755 6.39435 8.07808Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L16.5 3.5",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5L16.5 3.5L12.5 3.5",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedCall);
export default __webpack_public_path__ + "static/media/ic-shared-call.ce7ac65468bb864a41b589640755e57d.svg";
export { ForwardRef as ReactComponent };